import { List, Stack, Text, useTheme } from '@chakra-ui/react';

import {
  CombinedServiceInterface,
  ExtendedAddonInterface,
  ServiceInterface
} from 'types';

import { Loader } from 'ui';
import { ServiceItem, ServiceItemAccordion } from './components';

interface ServiceListProps {
  services: CombinedServiceInterface[];
  selectedItems: ServiceInterface[];
  isReviewTab: boolean;
  isLoading: boolean;
  onServiceClick: (service: ServiceInterface) => void;
}

const ServiceList = ({
  services,
  selectedItems,
  isReviewTab,
  onServiceClick,
  isLoading
}: ServiceListProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepService: { serviceList }
        }
      }
    }
  } = useTheme();

  const servicesLength = services?.length;
  const isServicesExist = servicesLength > 0;
  const currServicesItemsCount = servicesLength - 1;

  const handleClickItem = (item: ServiceInterface | ExtendedAddonInterface) => {
    onServiceClick(item as ServiceInterface);
  };

  const renderItems = () =>
    (services ?? []).map((service, index) => {
      const isMasterService = !!service?.is_master;
      const isLastItem = index === currServicesItemsCount;
      const isChecked = selectedItems.some((item) => item?.id === service?.id);

      return isMasterService ? (
        <ServiceItemAccordion
          key={service.id}
          services={service.svc_list}
          name={service.name}
          onClick={handleClickItem}
          selectedServices={selectedItems}
        />
      ) : (
        <ServiceItem
          key={service.id}
          service={service as ServiceInterface}
          onClick={handleClickItem}
          isChecked={isChecked}
          isLastItem={isLastItem}
          isAddonVariant={false}
        />
      );
    });

  const renderPlaceholder = () => (
    <Stack
      alignItems='center'
      justifyContent='center'
      width='100%'
      minHeight='20vh'
      height='100%'
    >
      <Text
        textAlign='center'
        color={serviceList.placeholderTextColor}
        fontSize='20px'
      >
        No services found
      </Text>
    </Stack>
  );

  const body = isServicesExist ? renderItems() : renderPlaceholder();

  return (
    <List
      p={0}
      position='relative'
      h='100%'
      borderLeft={{ base: 'none', md: '7px solid' }}
      borderLeftColor={{
        base: 'none',
        md: isReviewTab
          ? serviceList.reviewTabBorderColor
          : serviceList.defaultBorderColor
      }}
    >
      {isLoading ? <Loader absolute /> : body}
    </List>
  );
};

export default ServiceList;
